module.exports = __webpack_public_path__ + "img/import.65ad294c.svg";